// * Bind services api to vue context

import Vue from 'vue'
import Chat from '@/services/api/Chat'
import ChatReport from '@/services/api/ChatReport'

const api = {
  chat: new Chat(),
  chatReport: new ChatReport(),
}

Vue.prototype.$api = api

export default api
